import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./counterSlice";
import cartReducer from "./cartSlice";

export const store = configureStore({
    reducer: {
        counter: counterReducer, // هر slice را اینجا اضافه می‌کنیم
        cart: cartReducer, // هر slice را اینجا اضافه می‌کنیم
    },
});
